webpackJsonp([230733333609092],{

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Connect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'first'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint returns the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'first'
	      ),
	      ' resource matching the provided criteria.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is useful when you know an API has certain queries that will only ever return 0 or 1 results, but you do not know the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' of the resource you\'re looking for (or whether it exists at all).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Additionally, you could also use this blueprint to the return the ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'most recent'
	      ),
	      ' resource a user created, by saying "give me a list of data, sort by the date that data was created, and give me the first thing in that list".'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { connect } from \'lore-hook-connect\';\n\n      connect((getState, props) => {\n        return {\n          tweet: getState(\'tweet.first\', {\n            where: {\n              user: 1\n            },\n            pagination: {\n              _sort: \'createdAt\',\n              _order: \'desc\'\n            }\n          })\n        }\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When invoked, this blueprint will return one of three responses.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Response #1: Data is Fetching'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the query has never been asked, the response will look like this (because it\'s being retrieved from the API):'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      const tweet = {\n        state: PayloadStates.FETCHING\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Response #2: Data is Found'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the API response contains data, this will return the first resource in the list:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      const tweet = {\n        id: 1,\n        cid: \'1\',\n        state: PayloadStates.RESOLVED,\n        data: {\n          name: \'resource name\'\n        }\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Response #3: Data is Not Found'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If the API response contains NO data, this will return a resource declaring nothing was found, as well as the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'meta'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'query'
	      ),
	      ' parameters from the collection that describe what question was asked.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      const tweet = {\n        id: undefined,\n        cid: undefined,\n        state: PayloadStates.NOT_FOUND,\n        data: {},\n        error: {},\n        meta: { /* if applicable */ },\n        query: { /* if applicable */ }\n      };\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default _.defaultsDeep({\n\n        defaults: {\n          where: {},\n          pagination: {}\n        },\n\n        getPayload: function(reducerState, params, reducer) {\n          const jsonKey = toJsonKey(params);\n          const state = reducerState[jsonKey];\n\n          if (state) {\n            if (state.state !== PayloadStates.FETCHING) {\n              if (state.data.length === 0) {\n                return _.assign({}, {\n                  id: undefined,\n                  cid: undefined,\n                  state: PayloadStates.NOT_FOUND,\n                  data: {},\n                  error: {}\n                }, _.pick(state, [\'meta\', \'query\']));\n              }\n              return _.assign({}, state.data[0], _.pick(state, [\'meta\', \'query\']));\n            }\n          }\n\n          return state;\n        },\n\n        callAction: function(action, params) {\n          return action(params.where, params.pagination).payload;\n        },\n\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-connect-first-js-4f32dfc3def3230b3765.js